import styled from 'styled-components';

export const StyledShowMore = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.pink500};
  margin-left: 5px;
`;
